import { extendTheme } from '@chakra-ui/react';

import { Button, colors, breakpoints, textStyles, styles, Textarea, Input } from './themeConfig';

export const theme = extendTheme({
  components: { Button, Textarea, Input },
  styles,
  colors,
  breakpoints,
  textStyles,
});
